export const VOLTAGE_TIERS = [
  { key: 'ehv', label: 'EHV >=345 kV', min: 345, color: '#b45309', width: 4, radius: 7 },
  { key: 'hv', label: 'HV 100-345 kV', min: 100, color: '#f59e0b', width: 2.5, radius: 5 },
  { key: 'subtransmission', label: 'Sub-transmission 35-100 kV', min: 35, color: '#fbbf24', width: 1.5, radius: 4 },
  { key: 'distribution', label: 'Distribution <35 kV', min: 0, color: '#9ca3af', width: 1, radius: 3 }
]

const UNKNOWN = { key: 'unknown', label: 'Unknown voltage', color: '#d1d5db', width: 1.25, radius: 3 }
const VOLT_CLASS_KV = {
  'UNDER 100': 69,
  'Under 100': 69,
  '100-161': 138,
  '220-287': 230,
  '345': 345,
  '500': 500,
  '735 AND ABOVE': 765,
  '735 and Above': 765,
  DC: 500
}

export const voltageTier = (kv) => {
  const numeric = Number(kv)
  if (!Number.isFinite(numeric) || numeric <= 0) return UNKNOWN

  return VOLTAGE_TIERS.find((tier) => numeric >= tier.min) || VOLTAGE_TIERS[VOLTAGE_TIERS.length - 1]
}

export const voltClassColorPairs = () => Object.entries(VOLT_CLASS_KV).flatMap(([value, kv]) => [value, voltageTier(kv).color])
